import { render, staticRenderFns } from "./publishRecord.vue?vue&type=template&id=286fc826&scoped=true"
import script from "./publishRecord.vue?vue&type=script&lang=js"
export * from "./publishRecord.vue?vue&type=script&lang=js"
import style0 from "./publishRecord.vue?vue&type=style&index=0&id=286fc826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fc826",
  null
  
)

export default component.exports